import type { CallRequestReason } from 'mmfintech-backend-api/types'
import { tr } from 'mmfintech-commons'

export const MAX_DETAILS_LENGTH = 255

export const getCallRequestReasonOptions = (): { value: CallRequestReason; label: string }[] => [
  { value: 'ACCOUNT_QUESTION', label: tr('FRONTEND.CALL_REQUEST.REASON.ACCOUNT_QUESTION', 'Account question') },
  {
    value: 'ONBOARDING_QUESTION',
    label: tr('FRONTEND.CALL_REQUEST.REASON.ONBOARDING_QUESTION', 'Onboarding question')
  },
  { value: 'CARDS_ISSUE', label: tr('FRONTEND.CALL_REQUEST.REASON.CARDS_ISSUE', 'Cards issue') },
  {
    value: 'TRANSACTION_ISSUE',
    label: tr('FRONTEND.CALL_REQUEST.REASON.TRANSACTION_ISSUE', 'Transaction or transfer issue')
  },
  { value: 'CRYPTO_ISSUE', label: tr('FRONTEND.CALL_REQUEST.REASON.CRYPTO_ISSUE', 'Crypto issue') },
  { value: 'OTHER', label: tr('FRONTEND.CALL_REQUEST.REASON.OTHER', 'Other') }
]
